var map = {
	"./": [
		318,
		9
	],
	"./Content": [
		1137,
		9,
		1,
		2,
		0,
		8,
		9,
		264,
		269
	],
	"./Content.dictionary": [
		1139,
		3,
		111
	],
	"./Content.dictionary.json": [
		1139,
		3,
		111
	],
	"./Content.jsx": [
		1137,
		9,
		1,
		2,
		0,
		9,
		264,
		275
	],
	"./ContentDeferred": [
		368,
		9
	],
	"./ContentDeferred.jsx": [
		368,
		9
	],
	"./InterestingMatches": [
		1019,
		9,
		0,
		23
	],
	"./InterestingMatches/": [
		1019,
		9,
		0,
		23
	],
	"./InterestingMatches/InterestingMatches.dictionary": [
		1035,
		3,
		126
	],
	"./InterestingMatches/InterestingMatches.dictionary.json": [
		1035,
		3,
		126
	],
	"./InterestingMatches/InterestingMatches.module.scss": [
		838,
		9,
		281
	],
	"./InterestingMatches/actions": [
		97,
		9
	],
	"./InterestingMatches/actions.ts": [
		97,
		9
	],
	"./InterestingMatches/components/Contetnt": [
		924,
		9,
		0,
		24
	],
	"./InterestingMatches/components/Contetnt/": [
		924,
		9,
		0,
		24
	],
	"./InterestingMatches/components/Contetnt/Content.dictionary": [
		970,
		3,
		127
	],
	"./InterestingMatches/components/Contetnt/Content.dictionary.json": [
		970,
		3,
		127
	],
	"./InterestingMatches/components/Contetnt/Content.module.scss": [
		1034,
		9,
		282
	],
	"./InterestingMatches/components/Contetnt/index": [
		924,
		9,
		0,
		24
	],
	"./InterestingMatches/components/Contetnt/index.tsx": [
		924,
		9,
		0,
		24
	],
	"./InterestingMatches/components/Match": [
		842,
		9,
		25
	],
	"./InterestingMatches/components/Match/": [
		842,
		9,
		25
	],
	"./InterestingMatches/components/Match/Match.dictionary": [
		849,
		3,
		128
	],
	"./InterestingMatches/components/Match/Match.dictionary.json": [
		849,
		3,
		128
	],
	"./InterestingMatches/components/Match/index": [
		842,
		9,
		25
	],
	"./InterestingMatches/components/Match/index.tsx": [
		842,
		9,
		25
	],
	"./InterestingMatches/components/Sport": [
		969,
		9,
		129
	],
	"./InterestingMatches/components/Sport.tsx": [
		969,
		9,
		129
	],
	"./InterestingMatches/components/Stage": [
		875,
		9,
		130
	],
	"./InterestingMatches/components/Stage.tsx": [
		875,
		9,
		130
	],
	"./InterestingMatches/components/Tournament": [
		892,
		9,
		131
	],
	"./InterestingMatches/components/Tournament.jsx": [
		892,
		9,
		131
	],
	"./InterestingMatches/components/Union": [
		925,
		9,
		132
	],
	"./InterestingMatches/components/Union.jsx": [
		925,
		9,
		132
	],
	"./InterestingMatches/constants": [
		926,
		9,
		133
	],
	"./InterestingMatches/constants.ts": [
		926,
		9,
		133
	],
	"./InterestingMatches/index": [
		1019,
		9,
		0,
		23
	],
	"./InterestingMatches/index.jsx": [
		1019,
		9,
		0,
		23
	],
	"./InterestingMatches/reducer": [
		297,
		9
	],
	"./InterestingMatches/reducer/": [
		297,
		9
	],
	"./InterestingMatches/reducer/entities": [
		353,
		9
	],
	"./InterestingMatches/reducer/entities.js": [
		353,
		9
	],
	"./InterestingMatches/reducer/grid": [
		354,
		9
	],
	"./InterestingMatches/reducer/grid.js": [
		354,
		9
	],
	"./InterestingMatches/reducer/index": [
		297,
		9
	],
	"./InterestingMatches/reducer/index.js": [
		297,
		9
	],
	"./InterestingMatches/selectors": [
		829,
		9,
		26
	],
	"./InterestingMatches/selectors/": [
		829,
		9,
		26
	],
	"./InterestingMatches/selectors/entities": [
		275,
		9
	],
	"./InterestingMatches/selectors/entities.ts": [
		275,
		9
	],
	"./InterestingMatches/selectors/grid": [
		848,
		9,
		0,
		134
	],
	"./InterestingMatches/selectors/grid.ts": [
		848,
		9,
		0,
		134
	],
	"./InterestingMatches/selectors/index": [
		829,
		9,
		26
	],
	"./InterestingMatches/selectors/index.ts": [
		829,
		9,
		26
	],
	"./LandingPage.module.scss": [
		1178,
		9,
		283
	],
	"./MatchOfTheDay": [
		1020,
		9,
		2,
		0,
		9,
		27
	],
	"./MatchOfTheDay/": [
		1020,
		9,
		2,
		0,
		9,
		27
	],
	"./MatchOfTheDay/actions": [
		307,
		9
	],
	"./MatchOfTheDay/actions.ts": [
		307,
		9
	],
	"./MatchOfTheDay/components/Carousel": [
		971,
		9,
		2,
		0,
		9,
		28
	],
	"./MatchOfTheDay/components/Carousel/": [
		971,
		9,
		2,
		0,
		9,
		28
	],
	"./MatchOfTheDay/components/Carousel/Carousel.module.scss": [
		1138,
		9,
		284
	],
	"./MatchOfTheDay/components/Carousel/index": [
		971,
		9,
		2,
		0,
		9,
		28
	],
	"./MatchOfTheDay/components/Carousel/index.tsx": [
		971,
		9,
		2,
		0,
		9,
		28
	],
	"./MatchOfTheDay/components/MainStakes": [
		927,
		9,
		0,
		29
	],
	"./MatchOfTheDay/components/MainStakes/": [
		927,
		9,
		0,
		29
	],
	"./MatchOfTheDay/components/MainStakes/MainStakes.module.scss": [
		1036,
		9,
		285
	],
	"./MatchOfTheDay/components/MainStakes/index": [
		927,
		9,
		0,
		29
	],
	"./MatchOfTheDay/components/MainStakes/index.tsx": [
		927,
		9,
		0,
		29
	],
	"./MatchOfTheDay/components/MatchTile": [
		972,
		9,
		0,
		30
	],
	"./MatchOfTheDay/components/MatchTile/": [
		972,
		9,
		0,
		30
	],
	"./MatchOfTheDay/components/MatchTile/MatchDetails": [
		1037,
		9,
		138
	],
	"./MatchOfTheDay/components/MatchTile/MatchDetails.tsx": [
		1037,
		9,
		138
	],
	"./MatchOfTheDay/components/MatchTile/MatchTile.module.scss": [
		973,
		9,
		286
	],
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary": [
		1038,
		3,
		139
	],
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary.json": [
		1038,
		3,
		139
	],
	"./MatchOfTheDay/components/MatchTile/index": [
		972,
		9,
		0,
		30
	],
	"./MatchOfTheDay/components/MatchTile/index.tsx": [
		972,
		9,
		0,
		30
	],
	"./MatchOfTheDay/images/background.svg": [
		1198,
		1,
		287
	],
	"./MatchOfTheDay/images/pattern.svg": [
		1199,
		1,
		288
	],
	"./MatchOfTheDay/index": [
		1020,
		9,
		2,
		0,
		9,
		27
	],
	"./MatchOfTheDay/index.tsx": [
		1020,
		9,
		2,
		0,
		9,
		27
	],
	"./MatchOfTheDay/reducer": [
		355,
		9
	],
	"./MatchOfTheDay/reducer.ts": [
		355,
		9
	],
	"./MatchOfTheDay/selectors": [
		885,
		9,
		31
	],
	"./MatchOfTheDay/selectors/": [
		885,
		9,
		31
	],
	"./MatchOfTheDay/selectors/entities": [
		285,
		9
	],
	"./MatchOfTheDay/selectors/entities.ts": [
		285,
		9
	],
	"./MatchOfTheDay/selectors/grid": [
		915,
		9,
		0,
		140
	],
	"./MatchOfTheDay/selectors/grid.ts": [
		915,
		9,
		0,
		140
	],
	"./MatchOfTheDay/selectors/index": [
		885,
		9,
		31
	],
	"./MatchOfTheDay/selectors/index.ts": [
		885,
		9,
		31
	],
	"./MatchOfTheDay/utils/get-match-ids-from-banners": [
		1080,
		9,
		141
	],
	"./MatchOfTheDay/utils/get-match-ids-from-banners.ts": [
		1080,
		9,
		141
	],
	"./MiniBanners": [
		1021,
		9,
		1,
		32
	],
	"./MiniBanners/": [
		1021,
		9,
		1,
		32
	],
	"./MiniBanners/MiniBanners": [
		974,
		9,
		1,
		142
	],
	"./MiniBanners/MiniBanners.module.scss": [
		1039,
		9,
		289
	],
	"./MiniBanners/MiniBanners.tsx": [
		974,
		9,
		1,
		142
	],
	"./MiniBanners/components/Content": [
		893,
		9,
		1,
		33
	],
	"./MiniBanners/components/Content/": [
		893,
		9,
		1,
		33
	],
	"./MiniBanners/components/Content/Content": [
		876,
		9,
		1,
		143
	],
	"./MiniBanners/components/Content/Content.module.scss": [
		928,
		9,
		290
	],
	"./MiniBanners/components/Content/Content.tsx": [
		876,
		9,
		1,
		143
	],
	"./MiniBanners/components/Content/index": [
		893,
		9,
		1,
		33
	],
	"./MiniBanners/components/Content/index.ts": [
		893,
		9,
		1,
		33
	],
	"./MiniBanners/index": [
		1021,
		9,
		1,
		32
	],
	"./MiniBanners/index.ts": [
		1021,
		9,
		1,
		32
	],
	"./images/telegram.svg": [
		1200,
		1,
		332
	],
	"./index": [
		318,
		9
	],
	"./index.tsx": [
		318,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1265;
module.exports = webpackAsyncContext;